/* eslint-disable import/prefer-default-export */

export const MESSAGES_CHANGED = 'MESSAGES_CHANGED';
export const NEXT_PAGE_CHANGED = 'NEXT_PAGE_CHANGED';
export const HAS_MORE_CHANGED = 'HAS_MORE_CHANGED';
export const INBOX_MODAL_IS_OPEN_CHANGED = 'INBOX_MODAL_IS_OPEN_CHANGED';